{
	"arrived-to-iceland": "Arrived to Iceland",
	"delivered": "Delivered",
	"delivery-method": "Delivery method",
	"DPH": "Parcel home",
	"DPO": "Parcel locker",
	"DPP": "Parcel post office",
	"custNumber": "Customs number",
	"enter-shipment-code": "Enter shipment code",
	"estimated-delivery": "Estimated delivery",
	"home-delivery-message": "Do you want the parcel sent home?",
	"send-receipt": "Have you sent in your receipt yet?",
	"in-customs": "In customs",
	"in-origin-country": "In transit to Iceland",
	"in-iceland": "In Iceland",
	"invalid-shipment-code": "Invalid shipment code",
	"left-the-country": "Left the country",
	"mailed-date": "Mailed",
	"save-tracking-number": "Save the tracking number to create a shortcut for the shipment",
	"save": "Save",
	"name": "Name (Optional)",
	"order-home-delivery": "Order home delivery",
	"payment": "Payment",
	"ready-for-delivery": "Ready for delivery",
	"returned": "Returned",
	"redirect-to-first": "Ef þú ert viss um að sendingarnúmerið sé rétt þá er líklegt að sendingin sé ekki komin til okkar.",
	"redirect-to-second": "Þú getur skoðað stöðu á sendingunni alþjóðlega hérna: ",
	"search-for-shipment": "Search for shipment",
	"shipment-events": "Shipment history",
	"shipment-in-transit": "Shipment in transit",
	"shipment-received": "Shipment received",
	"shipment-registered": "Shipment registered",
	"shipmentInOurSystem": "Shipment is in our system",
	"status": "Status",
	"tracking-number": "Tracking number",
	"type": "Shipment type",
	"unknown-error": "Something went wrong, failed to track shipment",
	"waitingForDocuments": "Waiting for documents",
	"waitingForShipmentToArrive": "Waiting for shipment to arrive",
	"weight": "Weight",
	"multipleParcels": "Multiple parcels were found for this tracking number:"
}
